import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { Tabs, Tab, MenuItem } from '@material-ui/core';
import { FaBuilding } from 'react-icons/fa';
import * as Yup from 'yup';

import Paper from 'components/Paper';
import TextField from 'components/TextField';
import Button from 'components/Button';
import FornecedoresActions from 'store/ducks/fornecedores';
import NaturezasActions from 'store/ducks/naturezas';
import { fornecedoresAPI } from 'services/apiRest';

import {
  Container,
  WrapperBody,
  WrapperContent,
  WrapperBottom,
  WrapperInput,
  InputRow,
  TabsContainer,
  TabPanel,
  AutocompleteWrapper,
  AutocompleteDropdown,
  AutocompleteItem,
} from './styles';

// Lista de bancos brasileiros (código e nome)
const BANCOS = [
  { codigo: '246', nome: 'Banco ABC Brasil S.A.' },
  { codigo: '299', nome: 'Banco Afinz S.A. Banco Múltiplo' },
  { codigo: '121', nome: 'Banco Agibank S.A.' },
  { codigo: '065', nome: 'Banco Andbank (Brasil) S.A.' },
  { codigo: '096', nome: 'Banco B3 S.A.' },
  { codigo: '024', nome: 'Banco BANDEPE S.A.' },
  { codigo: '318', nome: 'Banco BMG S.A.' },
  { codigo: '233', nome: 'Banco BMG Soluções Financeiras S.A.' },
  { codigo: '752', nome: 'Banco BNP Paribas Brasil S.A.' },
  { codigo: '107', nome: 'Banco BOCOM BBM S.A.' },
  { codigo: '063', nome: 'Banco Bradescard S.A.' },
  { codigo: '036', nome: 'Banco Bradesco BBI S.A.' },
  { codigo: '394', nome: 'Banco Bradesco Financiamentos S.A.' },
  { codigo: '237', nome: 'Banco Bradesco S.A.' },
  { codigo: '218', nome: 'Banco BS2 S.A.' },
  { codigo: '208', nome: 'Banco BTG Pactual S.A.' },
  { codigo: '626', nome: 'Banco C6 Consignado S.A.' },
  { codigo: '473', nome: 'Banco Caixa Geral - Brasil S.A.' },
  { codigo: '040', nome: 'Banco Cargill S.A.' },
  { codigo: '745', nome: 'Banco Citibank S.A.' },
  { codigo: '756', nome: 'Banco Cooperativo Sicoob S.A.' },
  { codigo: '748', nome: 'Banco Cooperativo Sicredi S.A.' },
  { codigo: '222', nome: 'Banco Credit Agricole Brasil S.A.' },
  { codigo: '368', nome: 'Banco CSF S.A.' },
  { codigo: '003', nome: 'Banco da Amazônia S.A.' },
  { codigo: '707', nome: 'Banco Daycoval S.A.' },
  { codigo: '654', nome: 'Banco Digimais S.A.' },
  { codigo: '001', nome: 'Banco do Brasil S.A.' },
  { codigo: '047', nome: 'Banco do Estado de Sergipe S.A.' },
  { codigo: '037', nome: 'Banco do Estado do Pará S.A.' },
  { codigo: '041', nome: 'Banco do Estado do Rio Grande do Sul S.A.' },
  { codigo: '004', nome: 'Banco do Nordeste do Brasil S.A.' },
  { codigo: '224', nome: 'Banco Fibra S.A.' },
  { codigo: '094', nome: 'Banco Finaxis S.A.' },
  { codigo: '125', nome: 'Banco Genial S.A.' },
  { codigo: '612', nome: 'Banco Guanabara S.A.' },
  { codigo: '269', nome: 'Banco HSBC S.A.' },
  { codigo: '012', nome: 'Banco Inbursa S.A.' },
  { codigo: '604', nome: 'Banco Industrial do Brasil S.A.' },
  { codigo: '077', nome: 'Banco Inter S.A.' },
  { codigo: '249', nome: 'Banco Investcred Unibanco S.A.' },
  { codigo: '029', nome: 'Banco Itaú Consignado S.A.' },
  { codigo: '479', nome: 'Banco ItauBank S.A' },
  { codigo: '376', nome: 'Banco J. P. Morgan S.A.' },
  { codigo: '074', nome: 'Banco J. Safra S.A.' },
  { codigo: '217', nome: 'Banco John Deere S.A.' },
  { codigo: '600', nome: 'Banco Luso Brasileiro S.A.' },
  { codigo: '389', nome: 'Banco Mercantil do Brasil S.A.' },
  { codigo: '370', nome: 'Banco Mizuho do Brasil S.A.' },
  { codigo: '746', nome: 'Banco Modal S.A.' },
  { codigo: '066', nome: 'Banco Morgan Stanley S.A.' },
  { codigo: '456', nome: 'Banco MUFG Brasil S.A.' },
  { codigo: '007', nome: 'Banco Nacional de Desenvolvimento Econômico e Social - BNDES' },
  { codigo: '212', nome: 'Banco Original S.A.' },
  { codigo: '623', nome: 'Banco PAN S.A.' },
  { codigo: '611', nome: 'Banco Paulista S.A.' },
  { codigo: '643', nome: 'Banco Pine S.A.' },
  { codigo: '653', nome: 'Banco Pleno S.A.' },
  { codigo: '747', nome: 'Banco Rabobank International Brasil S.A.' },
  { codigo: '633', nome: 'Banco Rendimento S.A.' },
  { codigo: '120', nome: 'Banco Rodobens S.A.' },
  { codigo: '422', nome: 'Banco Safra S.A.' },
  { codigo: '033', nome: 'Banco Santander (Brasil) S.A.' },
  { codigo: '743', nome: 'Banco Semear S.A.' },
  { codigo: '276', nome: 'Banco Senff S.A.' },
  { codigo: '366', nome: 'Banco Société Générale Brasil S.A.' },
  { codigo: '464', nome: 'Banco Sumitomo Mitsui Brasileiro S.A.' },
  { codigo: '082', nome: 'Banco Topázio S.A.' },
  { codigo: '095', nome: 'Banco Travelex S.A.' },
  { codigo: '634', nome: 'Banco Triângulo S.A.' },
  { codigo: '505', nome: 'Banco UBS (Brasil) S.A.' },
  { codigo: '610', nome: 'Banco VR S.A.' },
  { codigo: '119', nome: 'Banco Western Union do Brasil S.A.' },
  { codigo: '348', nome: 'Banco XP S.A.' },
  { codigo: '021', nome: 'BANESTES S.A. Banco do Estado do Espírito Santo' },
  { codigo: '755', nome: 'Bank of America Merrill Lynch Banco Múltiplo S.A.' },
  { codigo: '320', nome: 'Bank Of China (Brasil) Banco Múltiplo S.A.' },
  { codigo: '496', nome: 'BBVA Brasil Banco de Investimento S.A.' },
  { codigo: '128', nome: 'Braza Bank S.A. Banco de Câmbio' },
  { codigo: '070', nome: 'BRB - Banco de Brasília S.A.' },
  { codigo: '104', nome: 'Caixa Econômica Federal' },
  { codigo: '477', nome: 'Citibank N.A.' },
  { codigo: '487', nome: 'Deutsche Bank S.A. - Banco Alemão' },
  { codigo: '144', nome: 'Ebury Banco de Câmbio S.A.' },
  { codigo: '341', nome: 'Itaú Unibanco S.A.' },
  { codigo: '488', nome: 'JPMorgan Chase Bank, National Association' },
  { codigo: '399', nome: 'Kirton Bank S.A. - Banco Múltiplo' },
  { codigo: '712', nome: 'Ouribank S.A. Banco Múltiplo' },
  { codigo: '254', nome: 'Paraná Banco S.A.' },
  { codigo: '751', nome: 'Scotiabank Brasil S.A. Banco Múltiplo' },
  { codigo: '014', nome: 'State Street Brasil S.A. - Banco Comercial' },
  { codigo: '129', nome: 'UBS Brasil Banco de Investimento S.A.' },
].sort((a, b) => parseInt(a.codigo) - parseInt(b.codigo));

// Validação com Yup
const validationSchema = Yup.object().shape({
  nome: Yup.string().required('Nome é obrigatório'),
  cpfCnpj: Yup.string()
    .required('CPF/CNPJ é obrigatório')
    .test('cpf-cnpj', 'CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos', (value) => {
      if (!value) return false;
      const cleaned = value.replace(/\D/g, '');
      return cleaned.length === 11 || cleaned.length === 14;
    }),
  endereco: Yup.string(),
  cidade: Yup.string(),
  uf: Yup.string().max(2, 'UF deve ter 2 caracteres'),
  cep: Yup.string().test('cep', 'CEP deve ter 8 dígitos', (value) => {
    if (!value) return true;
    const cleaned = value.replace(/\D/g, '');
    return cleaned.length === 8 || cleaned.length === 0;
  }),
  email: Yup.string().email('Email inválido'),
});

function FornecedorForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const { fornecedores, isLoading } = useSelector((state) => state.fornecedores);
  const { naturezas: naturezasState } = useSelector((state) => state.naturezas);
  const isEdit = !!id;
  const isView = window.location.pathname.includes('/view/');
  const [activeTab, setActiveTab] = useState(0);
  const [naturezaInput, setNaturezaInput] = useState('');
  const [showDropdownNatureza, setShowDropdownNatureza] = useState(false);
  const dropdownNaturezaRef = useRef(null);
  const [fornecedorCarregado, setFornecedorCarregado] = useState(null);

  // Converter naturezas de Immutable para array normal
  const naturezas = useMemo(() => {
    if (!naturezasState) return [];
    
    if (Array.isArray(naturezasState)) {
      return naturezasState;
    }
    
    if (naturezasState && typeof naturezasState === 'object') {
      if (typeof naturezasState.asMutable === 'function') {
        try {
          const mutable = naturezasState.asMutable({ deep: true });
          return Array.isArray(mutable) ? mutable : [];
        } catch (e) {
          console.warn('Erro ao converter Immutable:', e);
        }
      }
      
      if (typeof naturezasState.length === 'number') {
        try {
          return Array.from(naturezasState);
        } catch (e) {
          console.warn('Erro ao converter com Array.from:', e);
        }
      }
    }
    
    return [];
  }, [naturezasState]);

  // Buscar fornecedor individualmente se estiver editando ou visualizando
  useEffect(() => {
    if ((isEdit || isView) && id && !fornecedorCarregado) {
      const buscarFornecedorIndividual = async () => {
        try {
          const response = await fornecedoresAPI.buscarPorId(id);
          console.log('🔍 [FornecedorForm] Resposta completa da API:', response);
          console.log('🔍 [FornecedorForm] Dados bancários recebidos:', response.dadosBancarios);
          console.log('🔍 [FornecedorForm] Tipo de dadosBancarios:', typeof response.dadosBancarios);
          console.log('🔍 [FornecedorForm] dadosBancarios é null?', response.dadosBancarios === null);
          console.log('🔍 [FornecedorForm] dadosBancarios é undefined?', response.dadosBancarios === undefined);
          setFornecedorCarregado(response);
        } catch (error) {
          console.error('Erro ao buscar fornecedor:', error);
        }
      };
      buscarFornecedorIndividual();
    }
  }, [id, isEdit, isView, fornecedorCarregado]);

  const fornecedor = useMemo(() => {
    if (fornecedorCarregado) {
      console.log('✅ [FornecedorForm] Usando fornecedorCarregado:', fornecedorCarregado);
      return fornecedorCarregado;
    }
    if (isEdit || isView) {
      const fornecedorEncontrado = fornecedores.find((item) => item.id === id);
      console.log('✅ [FornecedorForm] Fornecedor encontrado na lista:', fornecedorEncontrado);
      return fornecedorEncontrado;
    }
    return null;
  }, [fornecedores, id, isEdit, isView, fornecedorCarregado]);

  // Carregar naturezas
  useEffect(() => {
    dispatch(NaturezasActions.getNaturezasRequest());
  }, [dispatch]);

  // Detectar tipo de pessoa baseado no CPF/CNPJ
  const detectTipoPessoa = (cpfCnpj) => {
    if (!cpfCnpj) return 'PF';
    const cleaned = cpfCnpj.replace(/\D/g, '');
    return cleaned.length === 11 ? 'PF' : 'PJ';
  };

  // Buscar CEP via ViaCEP
  const buscarCep = async (cepValue) => {
    const cepLimpo = cepValue.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();
      
      if (!data.erro) {
        formik.setFieldValue('endereco', data.logradouro || '');
        formik.setFieldValue('bairro', data.bairro || '');
        formik.setFieldValue('cidade', data.localidade || '');
        formik.setFieldValue('uf', data.uf || '');
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
    }
  };

  const formik = useFormik({
    initialValues: {
      nome: fornecedor?.nome || '',
      nomeFantasia: fornecedor?.nomeFantasia || '',
      cpfCnpj: fornecedor?.cpfCnpj || '',
      inscricaoEstadual: fornecedor?.inscricaoEstadual || '',
      tipoPessoa: fornecedor?.tipoPessoa || 'PF',
      endereco: fornecedor?.endereco || '',
      numero: fornecedor?.numero || '',
      complemento: fornecedor?.complemento || '',
      bairro: fornecedor?.bairro || '',
      cidade: fornecedor?.cidade || '',
      uf: fornecedor?.uf || '',
      cep: fornecedor?.cep || '',
      email: fornecedor?.email || '',
      telefoneContato: fornecedor?.telefoneContato || '',
      nomeContato: fornecedor?.nomeContato || '',
      prazoPagamento: fornecedor?.prazoPagamento || '',
      formaPagamento: fornecedor?.formaPagamento || '',
      dataInclusao: fornecedor?.dataInclusao ? fornecedor.dataInclusao.split('T')[0] : new Date().toISOString().split('T')[0],
      // Dados bancários - usar dadosBancarios mesmo se for null
      banco: (fornecedor?.dadosBancarios && fornecedor.dadosBancarios.banco) ? fornecedor.dadosBancarios.banco : '',
      agencia: (fornecedor?.dadosBancarios && fornecedor.dadosBancarios.agencia) ? fornecedor.dadosBancarios.agencia : '',
      numeroConta: (fornecedor?.dadosBancarios && fornecedor.dadosBancarios.numeroConta) ? fornecedor.dadosBancarios.numeroConta : '',
      chavePix: (fornecedor?.dadosBancarios && fornecedor.dadosBancarios.chavePix) ? fornecedor.dadosBancarios.chavePix : '',
      naturezaId: (fornecedor?.dadosBancarios && fornecedor.dadosBancarios.naturezaId) ? fornecedor.dadosBancarios.naturezaId : '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      let naturezaId = null;
      if (values.naturezaId !== undefined && values.naturezaId !== null && values.naturezaId !== '') {
        if (typeof values.naturezaId === 'string') {
          const trimmed = values.naturezaId.trim();
          if (trimmed === '') {
            naturezaId = null;
          } else {
            naturezaId = trimmed;
          }
        } else {
          naturezaId = String(values.naturezaId);
        }
      }

      const fornecedorData = {
        ...values,
        id: fornecedor?.id,
        tipoPessoa: detectTipoPessoa(values.cpfCnpj),
        dadosBancarios: {
          banco: values.banco || null,
          agencia: values.agencia || null,
          numeroConta: values.numeroConta || null,
          chavePix: values.chavePix || null,
          naturezaId: naturezaId || null,
        },
      };

      const handleSuccess = () => {
        history.push('/financeiro/fornecedores');
      };

      if (isEdit) {
        dispatch(
          FornecedoresActions.updateFornecedorRequest(fornecedorData, handleSuccess)
        );
      } else {
        dispatch(
          FornecedoresActions.addFornecedorRequest(fornecedorData, handleSuccess)
        );
      }
    },
  });

  useEffect(() => {
    if (fornecedor) {
      console.log('📥 [FornecedorForm] Fornecedor completo recebido:', {
        fornecedor,
        dadosBancarios: fornecedor.dadosBancarios,
        dadosBancariosType: typeof fornecedor.dadosBancarios,
        dadosBancariosIsNull: fornecedor.dadosBancarios === null,
        naturezaId: fornecedor.dadosBancarios?.naturezaId,
      });
      
      // Tratar dadosBancarios que pode ser null ou um objeto
      const dadosBancarios = fornecedor.dadosBancarios && fornecedor.dadosBancarios !== null 
        ? fornecedor.dadosBancarios 
        : {};
      const naturezaId = dadosBancarios.naturezaId || '';
      
      const valoresAtualizados = {
        nome: fornecedor.nome || '',
        nomeFantasia: fornecedor.nomeFantasia || '',
        cpfCnpj: fornecedor.cpfCnpj || '',
        inscricaoEstadual: fornecedor.inscricaoEstadual || '',
        tipoPessoa: fornecedor.tipoPessoa || 'PF',
        endereco: fornecedor.endereco || '',
        numero: fornecedor.numero || '',
        complemento: fornecedor.complemento || '',
        bairro: fornecedor.bairro || '',
        cidade: fornecedor.cidade || '',
        uf: fornecedor.uf || '',
        cep: fornecedor.cep || '',
        email: fornecedor.email || '',
        telefoneContato: fornecedor.telefoneContato || '',
        nomeContato: fornecedor.nomeContato || '',
        prazoPagamento: fornecedor.prazoPagamento || '',
        formaPagamento: fornecedor.formaPagamento || '',
        dataInclusao: fornecedor.dataInclusao ? fornecedor.dataInclusao.split('T')[0] : new Date().toISOString().split('T')[0],
        // Dados bancários
        banco: dadosBancarios.banco || '',
        agencia: dadosBancarios.agencia || '',
        numeroConta: dadosBancarios.numeroConta || '',
        chavePix: dadosBancarios.chavePix || '',
        naturezaId: naturezaId,
      };
      
      console.log('📥 [FornecedorForm] Valores que serão setados no formik:', valoresAtualizados);
      
      formik.setValues(valoresAtualizados);
      
      console.log('📥 [FornecedorForm] Formik atualizado. Valores após setValues:', {
        banco: formik.values.banco,
        agencia: formik.values.agencia,
        numeroConta: formik.values.numeroConta,
        chavePix: formik.values.chavePix,
        naturezaId: formik.values.naturezaId,
      });
      
      if (naturezaId && naturezas.length > 0) {
        const naturezaSelecionada = naturezas.find(n => String(n.id) === String(naturezaId));
        if (naturezaSelecionada) {
          setNaturezaInput(`${naturezaSelecionada.codigo || ''} - ${naturezaSelecionada.descricao || ''}`);
        }
      }
    }
  }, [fornecedor, naturezas]);

  // Forçar atualização dos dados bancários quando a aba for aberta
  useEffect(() => {
    if (activeTab === 1 && fornecedor) {
      console.log('🔄 [FornecedorForm] Aba de dados bancários aberta, verificando valores:', {
        formikBanco: formik.values.banco,
        formikAgencia: formik.values.agencia,
        fornecedorDadosBancarios: fornecedor.dadosBancarios,
      });
      
      const dadosBancarios = fornecedor.dadosBancarios && fornecedor.dadosBancarios !== null 
        ? fornecedor.dadosBancarios 
        : {};
      
      // Se os valores do formik estão vazios mas há dados no fornecedor, atualizar
      if (!formik.values.banco && dadosBancarios.banco) {
        console.log('🔄 [FornecedorForm] Atualizando valores bancários na aba:', dadosBancarios);
        formik.setFieldValue('banco', dadosBancarios.banco || '');
        formik.setFieldValue('agencia', dadosBancarios.agencia || '');
        formik.setFieldValue('numeroConta', dadosBancarios.numeroConta || '');
        formik.setFieldValue('chavePix', dadosBancarios.chavePix || '');
        formik.setFieldValue('naturezaId', dadosBancarios.naturezaId || '');
      }
    }
  }, [activeTab, fornecedor]);

  // Formatar CPF/CNPJ
  const formatCpfCnpj = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  };

  // Formatar CEP
  const formatCep = (value) => {
    const cleaned = value.replace(/\D/g, '');
    return cleaned.replace(/(\d{5})(\d{3})/, '$1-$2');
  };

  // Formatar telefone
  const formatTelefone = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 10) {
      return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  };

  const handleCpfCnpjChange = (e) => {
    const formatted = formatCpfCnpj(e.target.value);
    formik.setFieldValue('cpfCnpj', formatted);
    formik.setFieldValue('tipoPessoa', detectTipoPessoa(formatted));
  };

  const handleCepChange = async (e) => {
    const formatted = formatCep(e.target.value);
    formik.setFieldValue('cep', formatted);
    
    const cepLimpo = formatted.replace(/\D/g, '');
    if (cepLimpo.length === 8) {
      await buscarCep(formatted);
    }
  };

  const handleTelefoneChange = (e) => {
    const formatted = formatTelefone(e.target.value);
    formik.setFieldValue('telefoneContato', formatted);
  };

  // Filtrar naturezas baseado no input
  const naturezasFiltradas = useMemo(() => {
    if (!naturezaInput || naturezaInput.trim() === '') {
      return naturezas;
    }
    const searchTerm = naturezaInput.toLowerCase();
    return naturezas.filter((n) => {
      const codigo = String(n.codigo || '').toLowerCase();
      const descricao = String(n.descricao || '').toLowerCase();
      return codigo.includes(searchTerm) || descricao.includes(searchTerm);
    });
  }, [naturezaInput, naturezas]);

  // Selecionar natureza
  const handleSelecionarNatureza = (natureza) => {
    formik.setFieldValue('naturezaId', natureza.id);
    setNaturezaInput(`${natureza.codigo || ''} - ${natureza.descricao || ''}`);
    setShowDropdownNatureza(false);
  };

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownNaturezaRef.current && !dropdownNaturezaRef.current.contains(event.target)) {
        setShowDropdownNatureza(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Container>
      <Paper
        title={isView ? 'VISUALIZAR FORNECEDOR' : isEdit ? 'EDITAR FORNECEDOR' : 'NOVO FORNECEDOR'}
        icon={<FaBuilding size={24} style={{ color: '#122d58', marginRight: '25px' }} />}
        rightContent={
          !isView && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Button
                label="Cancelar"
                onClick={() => history.push('/financeiro/fornecedores')}
                type="button"
                width="120px"
              />
              <Button
                label={isEdit ? 'Atualizar' : 'Salvar'}
                type="button"
                width="120px"
                onClick={() => {
                  formik.handleSubmit();
                }}
                disabled={isLoading}
              />
            </div>
          )
        }
      >
        <form onSubmit={formik.handleSubmit}>
          <TabsContainer>
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Dados do Fornecedor" />
              <Tab label="Dados Bancários" />
            </Tabs>
          </TabsContainer>

          {activeTab === 0 && (
            <TabPanel>
              <WrapperBody>
                <WrapperContent>
                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Nome *"
                        name="nome"
                        value={formik.values.nome}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nome && formik.errors.nome}
                        disabled={isView}
                        color="#122d58"
                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Nome Fantasia"
                        name="nomeFantasia"
                        value={formik.values.nomeFantasia}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nomeFantasia && formik.errors.nomeFantasia}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="CPF/CNPJ *"
                        name="cpfCnpj"
                        value={formik.values.cpfCnpj}
                        onChange={handleCpfCnpjChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cpfCnpj && formik.errors.cpfCnpj}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Tipo de Pessoa"
                        name="tipoPessoa"
                        value={formik.values.tipoPessoa === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}
                        disabled
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Inscrição Estadual"
                        name="inscricaoEstadual"
                        value={formik.values.inscricaoEstadual}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.inscricaoEstadual && formik.errors.inscricaoEstadual}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="CEP"
                        name="cep"
                        value={formik.values.cep}
                        onChange={handleCepChange}
                        onBlur={async (e) => {
                          formik.handleBlur(e);
                          const cepLimpo = formik.values.cep.replace(/\D/g, '');
                          if (cepLimpo.length === 8) {
                            await buscarCep(formik.values.cep);
                          }
                        }}
                        error={formik.touched.cep && formik.errors.cep}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Endereço"
                        name="endereco"
                        value={formik.values.endereco}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.endereco && formik.errors.endereco}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Número"
                        name="numero"
                        value={formik.values.numero}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.numero && formik.errors.numero}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Complemento"
                        name="complemento"
                        value={formik.values.complemento}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.complemento && formik.errors.complemento}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Bairro"
                        name="bairro"
                        value={formik.values.bairro}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.bairro && formik.errors.bairro}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Cidade"
                        name="cidade"
                        value={formik.values.cidade}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cidade && formik.errors.cidade}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="UF"
                        name="uf"
                        value={formik.values.uf}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.uf && formik.errors.uf}
                        disabled={isView}
                        maxLength={2}
                        color="#122d58"

                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && formik.errors.email}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Telefone Contato (com DDD)"
                        name="telefoneContato"
                        value={formik.values.telefoneContato}
                        onChange={handleTelefoneChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.telefoneContato && formik.errors.telefoneContato}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Nome do Contato"
                        name="nomeContato"
                        value={formik.values.nomeContato}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nomeContato && formik.errors.nomeContato}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Data Inclusão"
                        name="dataInclusao"
                        type="date"
                        value={formik.values.dataInclusao}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.dataInclusao && formik.errors.dataInclusao}
                        disabled={isView}
                        color="#122d58"

                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Prazo de Pagamento (dias)"
                        name="prazoPagamento"
                        type="number"
                        value={formik.values.prazoPagamento}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                        disabled={isView}
                        inputProps={{ min: 0, step: 1 }}
                        placeholder="Ex: 10, 20, 30"
                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Forma de Pagamento"
                        name="formaPagamento"
                        select
                        value={formik.values.formaPagamento || ''}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        fullWidth
                        color="secondary"
                        disabled={isView}
                      >
                        <MenuItem value="">Selecione...</MenuItem>
                        <MenuItem value="Cartao de Credito">Cartão de Crédito</MenuItem>
                        <MenuItem value="Boleto">Boleto</MenuItem>
                        <MenuItem value="Pix">Pix</MenuItem>
                      </TextField>
                    </WrapperInput>
                  </InputRow>
                </WrapperContent>
              </WrapperBody>
            </TabPanel>
          )}

          {activeTab === 1 && (
            <TabPanel>
              <WrapperBody>
                <WrapperContent>
                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Banco"
                        name="banco"
                        value={formik.values.banco}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.banco && formik.errors.banco}
                        disabled={isView}
                        color="#122d58"
                        select
                      >
                        <MenuItem value="">
                          <em>Selecione um banco</em>
                        </MenuItem>
                        {BANCOS.map((banco) => (
                          <MenuItem key={banco.codigo} value={`${banco.codigo} - ${banco.nome}`}>
                            {banco.codigo} - {banco.nome}
                          </MenuItem>
                        ))}
                      </TextField>
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Agência"
                        name="agencia"
                        value={formik.values.agencia}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.agencia && formik.errors.agencia}
                        disabled={isView}
                        color="#122d58"
                      />
                    </WrapperInput>
                    <WrapperInput>
                      <TextField
                        label="Número da Conta"
                        name="numeroConta"
                        value={formik.values.numeroConta}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.numeroConta && formik.errors.numeroConta}
                        disabled={isView}
                        color="#122d58"
                      />
                    </WrapperInput>
                  </InputRow>

                  <InputRow>
                    <WrapperInput>
                      <TextField
                        label="Chave PIX"
                        name="chavePix"
                        value={formik.values.chavePix}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.chavePix && formik.errors.chavePix}
                        disabled={isView}
                        color="#122d58"
                      />
                    </WrapperInput>
                    <WrapperInput>
                      <AutocompleteWrapper ref={dropdownNaturezaRef}>
                        <TextField
                          label="Natureza"
                          name="naturezaId"
                          value={naturezaInput}
                          onChange={(e) => {
                            setNaturezaInput(e.target.value);
                            setShowDropdownNatureza(true);
                          }}
                          onFocus={() => setShowDropdownNatureza(true)}
                          disabled={isView}
                          placeholder="Digite para buscar..."
                          color="#122d58"
                        />
                        {showDropdownNatureza && naturezasFiltradas.length > 0 && (
                          <AutocompleteDropdown>
                            {naturezasFiltradas.map((natureza) => (
                              <AutocompleteItem
                                key={natureza.id}
                                onClick={() => handleSelecionarNatureza(natureza)}
                              >
                                {natureza.codigo || ''} - {natureza.descricao || ''}
                              </AutocompleteItem>
                            ))}
                          </AutocompleteDropdown>
                        )}
                      </AutocompleteWrapper>
                    </WrapperInput>
                  </InputRow>
                </WrapperContent>
              </WrapperBody>
            </TabPanel>
          )}
        </form>
      </Paper>
    </Container>
  );
}

export default FornecedorForm;

